import { useCallback, useRef } from "react";
import { useTimesheetFlow } from "@/features/timesheetFlow/useTimesheetFlow";
import { getOrderForTimesheet } from "@/features/timesheetFlow/timesheetFlowApi";
import type { CreatedOrder } from "@/lib/projects";
import { toast } from "@/lib/toast";
import { useOnProjectCreated } from "@/pages/projekte/useNewProject";

/**
 * Nach Projekterstellung: wenn im Anlege-Dialog „bereits beauftragt“ mit Ja
 * beantwortet wurde, öffnet sich direkt der „Mündlich beauftragt“-Flow.
 *
 * Muss innerhalb von NewProjectProvider und TimesheetFlowProvider laufen.
 */
export function AskCommissionAfterCreateHost() {
  const { openMuendlichBeauftragt } = useTimesheetFlow();
  const openingRef = useRef(false);

  useOnProjectCreated(
    useCallback(
      (order: CreatedOrder) => {
        if (!order?.id || !order.ask_commission_after_create || openingRef.current) {
          return;
        }
        openingRef.current = true;
        void (async () => {
          try {
            const full = await getOrderForTimesheet(order.id);
            openMuendlichBeauftragt(full);
          } catch (err) {
            toast.error(
              err instanceof Error
                ? err.message
                : "Mündliche Beauftragung konnte nicht geöffnet werden.",
            );
          } finally {
            openingRef.current = false;
          }
        })();
      },
      [openMuendlichBeauftragt],
    ),
  );

  return null;
}
